<template lang="pug">
div
  div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('provider_service') }}
  div.text-sm.neutral500--text {{ $t('provider_service_desc') }}

  div.text-md.font-medium.neutral700--text.mt-8 {{ $t('configure_type_services') }}
  div.d-flex.align-center
    v-spacer
    assign-service-dropdown(:selectedServices="services" @added="attachServices($event)")
  
  .service-list
    v-data-table.mt-sm-4.pb-16(:headers="headers" :items="services" item-key="id" :items-per-page="-1" :hide-default-header="services.length === 0 && !isFetching" hide-default-footer disable-sort :loading="isFetching")
      template(v-slot:no-data)
        div.empty-box.mt-6.pa-8(align="center")
          v-avatar(color="neutral300" size="54")
            v-icon(color="neutral500" size="30") $yzi-medical-cross
          div.text-center.text-md.font-semibold.neutral700--text.mt-8 {{ $t('empty_assign_services') }}
          div.text-center.text-sm.font-normal.neutral500--text.mt-1 {{ $t('empty_assign_services_desc') }}
      template(v-slot:item.duration_value="{ item, headers, index }")
        div {{ item.duration_value }} {{ item.duration_unit }}
      template(v-slot:item.booking_fee="{ item, headers, index }")
        div {{ item.booking_fee | displayPrice($currency) }}
      template(v-slot:item.action="{ item, headers, index }")
        div(align="end")
          v-btn.ml-4(icon small @click="deleteProvider(item)")
            v-icon(color="neutral700" size="18") $yzi-trash-03

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AssignServiceDropdown from '@/components/clinic/appointment/custom/AssignServiceDropdown.vue'

export default {
  name: 'ProviderService',
  components: { AssignServiceDropdown },
  data: () => ({
    isFetching: false,
    isLoading: false,
    searchText: '',
    services: [],
    headers: [
      {
        text: 'Service',
        value: 'name',
        enable: true,
        class: 'text-xs font-bold neutral500--text text-uppercase'
      },
      {
        text: 'Duration',
        value: 'duration_value',
        enable: true,
        class: 'text-xs font-bold neutral500--text text-uppercase'
      },
      {
        text: 'Booking Fee',
        value: 'booking_fee',
        enable: true,
        class: 'text-xs font-bold neutral500--text text-uppercase'
      },
      {
        text: 'Action',
        value: 'action',
        enable: true,
        class: 'text-xs font-bold text-end neutral500--text text-uppercase'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      provider: 'clinic/getProvider',
      tempLoading: 'clinic/getTempLoading'
    }),
    servicesData () {
      return {
        services: this.services.map(m => m.id)
      }
    }
  },
  watch: {
    servicesData: {
      deep: true,
      handler (val) {
        this.$store.commit('clinic/updateTempProvider', val)
      }
    }
  },
  mounted () {
    if (this.provider) {
      this.setData(this.provider)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (provider) {
      this.services = [...provider.services]
    },
    addNewProvider () {
      this.$emit('addNewProvider')
    },
    attachServices (services) {
      services.forEach(o => {
        this.services.push(o)
      })
    },
    deleteProvider (item) {
      this.services = this.services.filter(f => f.id !== item.id)
    }
  }
}
</script>

<style scoped>
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
</style>